import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectClassConfig {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectClassConfig = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectClassConfig) => {
  const itemList = useStoreState((state) => state.student.classConfigList);
  const itemListFetch = useStoreActions((state) => state.student.fetchClassConfigList);

  if (itemList === null) {
    itemListFetch();
  }
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      className="sectionSelect"
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Section"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}  >
            {type.classConfigName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Section</Option>
      )}
    </Select>
  );
};
